/**
 * @description 值是否在数组中
 * @param {string|number} value
 * @param {array} valueList
 * @return {boolean}
 */
export const oneOf = (value, valueList) => {
  for (let i = 0; i < valueList.length; i++) {
    if (value === valueList[i]) {
      return true
    }
  }
  return false
}

/**
* @description 特殊替换
* @param {object} obj1
* @param {object} obj2
* @return {object}
*/
export const replaceObj = (obj1, obj2) => {
	for (let key in obj1) {
    if (obj2[`_${key}/a`] !== undefined) {// 数组
      obj1[key] = obj2[`_${key}/a`]
    } else if (obj2[`_${key}/d`] !== undefined) {// 数字
      obj1[key] = obj2[`_${key}/d`]
    } else if (obj2[`_${key}/s`] !== undefined) {// 字符串
      obj1[key] = obj2[`_${key}/s`]
    } else if (obj2[`_${key}/m`] !== undefined) {// 混合
      obj1[key] = obj2[`_${key}/m`]
    } else if (obj2[key] !== undefined) {
      obj1[key] = obj2[key]
    }
	}
	return obj1;
}

/**
 * @description 获取唯一的ID
 * @return {string}
 */
export const uniqid = () => {
  let s = []
  var hexDigits = "0123456789abcdef"
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = "4"
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
  s[8] = s[13] = s[18] = s[23] = "-"
  return s.join("")
}

/**
 * @description 下载文件
 */
export const downloadFile= (filename, content, type = 'text/html')=> {
  const blob = new Blob([content], { type })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename

  // 模拟点击
  document.body.appendChild(a)
  a.click()

  // 清理
  setTimeout(() => {
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
  })
}

/**
 * @description 数字格式化
 */
export const toNumber = value=> {
  const num = Number(value)
  return isNaN(num) ? 0 : num
}

/**
 * @description 小数四舍五入到指定位数
 */
export const round = (num, decimal = 0)=> {
  const base = Math.pow(10, decimal); // 计算放大倍数（10的decimal次方）
  return Math.round(toNumber(num) * base) / base;
}